import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import LiveEventsManage from './Videos/LiveEventsManage';
import LiveTVsManage from './Videos/LiveTVsManage';
import VideosManage from './Videos/VideosManage';
import VideoProviders from './Videos/Provider';
import ViewsStats from './Videos/views_stats';
import { useEffect, useState } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ManageVideos() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [loggedInProvider, setLoggedInProvider] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    const storedProvider = JSON.parse(localStorage.getItem("provider"));
    if (storedProvider) {
      if (storedProvider.userType === "admin") {
        setIsAdmin(true);
      } else if (storedProvider.id === "8b1fa3") {
        setIsAdmin(true)
      }
      else {
        setIsAdmin(false)
      }
      setLoggedInProvider(storedProvider);
    }
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs textColor='inherit' value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Live TVs" {...a11yProps(0)} />
          <Tab label="Live Events" {...a11yProps(1)} />
          <Tab label="Videos" {...a11yProps(2)} />
          {/* {isAdmin && (
            <Tab label="Providers" {...a11yProps(3)} />
          )} */}
          {/* <Tab label="Providers" {...a11yProps(3)} /> */}

        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <LiveTVsManage loggedInProvider={loggedInProvider} isAdmin={isAdmin} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <LiveEventsManage loggedInProvider={loggedInProvider} isAdmin={isAdmin} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <VideosManage loggedInProvider={loggedInProvider} isAdmin={isAdmin} />
      </CustomTabPanel>

      {isAdmin && (
        <CustomTabPanel value={value} index={3}>
          <VideoProviders />
        </CustomTabPanel>
      )}

      {/* <CustomTabPanel value={value} index={3}>
        <VideoProviders />
      </CustomTabPanel> */}

      {/* <CustomTabPanel value={value} index={4}>
        <ViewsStats/>
      </CustomTabPanel> */}

    </Box>
  );
}